export default __webpack_public_path__ + "static/media/fondo.64328e70.jpg";